import {Color, Mesh, MeshStandardMaterial, Object3D} from "three";

const isExistParent = (parentNode: Object3D, parentName: string): boolean => {
    if (parentNode.name === parentName) {
        return true
    } else {
        if (!parentNode.parent) {
            return false
        }
        return isExistParent(parentNode.parent, parentName)
    }


}

/**
 * рекурсивно изменяет цвет у всех потомков
 * @param {Object3D} object3D объект ThreeJS, имеющий потомков
 * @param {*} color цвет
 */
export const changeAllChildrenMaterial = (
    object3D: Object3D,
    color: number | Color,
    params?: Partial<Record<keyof MeshStandardMaterial, any>>,
    itemId?: string,
) => {
    object3D.traverse((obj) => {
        if ((obj as Mesh).material) {
            const mesh = obj as Mesh;
            if (itemId && mesh.parent && !isExistParent(mesh.parent, itemId) && mesh.name !== itemId ) {
                return
            }
            if (Array.isArray(mesh.material) && mesh.material.length > 0) {
                mesh.material.forEach((material) => {
                    const mat = material as MeshStandardMaterial;
                    const newMat = mat.clone();
                    if (typeof color === 'number') {
                        newMat.color.setHex(color);
                    } else {
                        newMat.color.set(color)
                    }
                    newMat.setValues({...params});
                    mesh.material = newMat;
                });
            } else {
                if (!Array.isArray(mesh.material)) {
                    mesh.material = mesh.material.clone();
                    if (typeof color === 'number') {
                        (mesh.material as MeshStandardMaterial).color.setHex(color);
                    } else {
                        (mesh.material as MeshStandardMaterial).color.set(color);
                    }
                    mesh.material.setValues({ ...params });
                }
            }
        }
    });
};
